import { render, staticRenderFns } from "./historyPage.vue?vue&type=template&id=2c9a562b&scoped=true&"
import script from "./historyPage.vue?vue&type=script&lang=js&"
export * from "./historyPage.vue?vue&type=script&lang=js&"
import style0 from "./historyPage.vue?vue&type=style&index=0&id=2c9a562b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a562b",
  null
  
)

export default component.exports